import { FieldExtensionComponentProps } from "@backstage/plugin-scaffolder-react";
import { type Option, Select } from "@backstage/ui";

import { useEnvironmentApps } from "../hooks";

/**
 * Scaffolder field extension that renders a select input populated with
 * environment app names fetched from GitHub via `githubApiRef`.
 *
 * Displays a loading placeholder while data is being fetched.
 *
 * @param props - Standard scaffolder field extension component props.
 */
export const EnvironmentsAppSelectFieldExtension = ({
    onChange,
    rawErrors,
    required,
    formData,
}: FieldExtensionComponentProps<string>) => {
    const { apps, loading } = useEnvironmentApps();
    if (loading) {
        return <div>Environment Apps...</div>;
    }
    const options: Option[] = apps.map(app => ({
        value: app,
        label: app,
    }));
    return (
        <Select
            label="App Name"
            isRequired={required}
            isInvalid={rawErrors?.length > 0 && !formData}
            options={options}
            value={formData}
            onChange={key => onChange(String(key))}
        />
    );
};
